"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocalStorageAvailable = void 0;
/* eslint-disable no-undef */
function isLocalStorageAvailable() {
    var mod = '__SPLITSOFTWARE__';
    try {
        localStorage.setItem(mod, mod);
        localStorage.removeItem(mod);
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.isLocalStorageAvailable = isLocalStorageAvailable;
